import React from "react"

interface Props {
  isMobile: boolean
}

export default function FunnelIcon({ isMobile }: Props) {
  return isMobile ? (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="4" fill="#2962FF" />
      <path
        d="M3.3338 4.75C3.3338 4.19772 3.78152 3.75 4.3338 3.75H5.66714C6.21942 3.75 6.66713 4.19772 6.66713 4.75V15.25C6.66713 15.8023 6.21942 16.25 5.66713 16.25H4.3338C3.78152 16.25 3.3338 15.8023 3.3338 15.25V4.75Z"
        fill="white"
      />
      <rect x="8.3338" y="9.16992" width="3.33333" height="7.08333" rx="1" fill="white" />
      <rect x="13.3338" y="13.3301" width="3.33333" height="2.91667" rx="1" fill="white" />
    </svg>
  ) : (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="8" fill="#2962FF" />
      <rect x="6.6665" y="7.5" width="6.66667" height="25" rx="1" fill="white" />
      <rect x="16.6665" y="18.3333" width="6.66667" height="14.1667" rx="1" fill="white" />
      <rect x="26.6665" y="26.6667" width="6.66667" height="5.83333" rx="1" fill="white" />
    </svg>
  )
}
